<template>
	<nta-dialog
		:show="show"
		:title="notification.label"
		height="auto"
		:symbol-lang="domainStore.languagePreference"
		@close="done"
	>
		<template #actions>
			<v-btn color="error" variant="tonal" @click="remove">{{
				symbolsStore.GUILabel("3cd68c08-7bc1-43b7-b38f-aed2dba9795e")
			}}</v-btn>
			<v-btn variant="tonal" @click="done">{{
				symbolsStore.GUILabel("a8a09d33-3550-403b-867b-9da2eee2d244")
			}}</v-btn>
		</template>
		<template #default>
			<v-card-text :style="{ 'max-height': imagesExist() ? '105px' : '600px', 'overflow-y': 'auto' }">
				{{ notification.description }}
			</v-card-text>
			<v-container v-if="imagesExist()">
				<v-carousel
					color="primary"
					height="450"
					:hide-delimiters="!showControls"
					@mouseenter="showControls = true"
					@mouseleave="showControls = false"
				>
					<template #default>
						<v-carousel-item v-for="img in notification.images" :src="img" :cover="cover">
							<v-icon
								v-if="showControls"
								color="primary"
								style="position: absolute; top: 10px; right: 10px"
								@click="toggleObjectFit"
							>
								mdi-image-filter-center-focus
							</v-icon>
						</v-carousel-item>
					</template>
					<template #prev="{ props }">
						<transition name="fade">
							<v-btn
								v-if="showControls"
								color="primary"
								icon="mdi-chevron-left"
								variant="flat"
								@click="props.onClick"
							></v-btn>
						</transition>
					</template>
					<template #next="{ props }">
						<transition name="fade">
							<v-btn
								v-if="showControls"
								color="primary"
								icon="mdi-chevron-right"
								variant="flat"
								@click.native="props.onClick"
							></v-btn>
						</transition>
					</template>
				</v-carousel>
			</v-container>
		</template>
	</nta-dialog>
</template>

<script setup lang="ts">
import { DescriptorNotification } from "@lr-notitia/notitia-operator/schemas";
import { ref, watch } from "vue";
import { useGraphStore } from "../../../store/graph";
import { useSymbolsStore } from "../../../store/symbols";
import { useDomainStore } from "../../../store/domain";

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();
const domainStore = useDomainStore();

const compProps = defineProps<{
	notification: DescriptorNotification;
}>();
const emits = defineEmits(["done"]);

const show = ref(true);
const showControls = ref(false);
const cover = ref(false);

function imagesExist(): boolean {
	return compProps.notification.images !== undefined && compProps.notification.images.length > 0;
}

function done() {
	show.value = false;
	emits("done");
}
function remove() {
	show.value = false;
	graphStore.descriptor.notification.remove(compProps.notification.id);
	emits("done");
}
function toggleObjectFit() {
	cover.value = !cover.value;
}

watch(
	() => compProps.notification,
	() => {
		show.value = true;
		showControls.value = false;
		cover.value = false;
	},
	{ immediate: true }
);
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
